import { css } from 'linaria';

export const reviewsSection = css`
  padding: 80px 0;
  background-color: var(--control-primary);

  @media (--only-desktop) {
    margin-bottom: 80px;
  }

  @media (--only-tablet) {
    padding: 64px 0;
  }

  @media (--only-mobile) {
    padding: 40px 0;
    border-radius: 12px 12px 0 0;
  }
`;

export const reviewsSectionTitle = css`
  && {
    width: 553px;
    margin-bottom: 48px;

    @media (--to-desktop) {
      margin-bottom: 24px;
    }

    @media (--only-mobile) {
      width: 100%;

      span {
        display: block;
        margin-top: 8px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;

export const reviewsLink = css`
  display: inline-block;
  border-bottom: 2px solid var(--control-accent);

  &:hover {
    background-color: var(--brand-dark);
    border-radius: var(--rounding-m) var(--rounding-m) 0 0;
  }
`;

export const reviewTextWrapper = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 24px;
`;

export const reviewsDescription = css`
  && {
    line-height: 28px;

    @media (--only-mobile) {
      line-height: 24px;
    }
  }
`;
